export const COOKIES_STORAGE_KEY = 'cookies_v2'
export const LEGACY_COOKIES_STORAGE_KEY = 'cookies'

export const COOKIES_EXPIRE_STORAGE_KEY = 'cookies_expire_v2'
export const LEGACY_COOKIES_EXPIRE_STORAGE_KEY = 'cookies_expire'
